import {
    DirectoryEntityType,
    DirectoryHealthCareProviderAddDto,
    DirectoryHealthCareProviderModifyDto,
    DirectoryHealthCareProviderSearchDto,
    DirectoryLinkedEstablishmentAndFaxNumber
} from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { DirectorySearchHelper } from "@/ContactDirectory/Helpers/DirectorySearchHelper";
import { PhoneNumberHelper } from "@/ContactDirectory/Helpers/PhoneNumberHelper";
import { DirectoryHealthCareProvider } from "@/ContactDirectory/Models/DirectoryHealthCareProvider";
import { DirectorySelectableEntity } from "@/ContactDirectory/Models/DirectorySelectableEntity";
import { DirectoryOtherEstablishmentMapper } from "./DirectoryOtherEstablishmentMapper";

export class DirectoryHealthCareProviderMapper {
    public static toModifyDto(healthCareProvider: DirectoryHealthCareProvider): DirectoryHealthCareProviderModifyDto {
        if (!healthCareProvider)
            throw new Error("healthCareProvider cannot be null");

        let linkedEstablishmentsAndFaxNumbersId: DirectoryLinkedEstablishmentAndFaxNumber[] = [];
        for (let i = 0; i < healthCareProvider.linkedEstablishments.length; i++) {
            linkedEstablishmentsAndFaxNumbersId.push({
                establishmentId: healthCareProvider.linkedEstablishments?.[i]?.id,
                faxNumberId: healthCareProvider.linkedFaxNumbers?.[i]?.id
            });
        }

        linkedEstablishmentsAndFaxNumbersId = linkedEstablishmentsAndFaxNumbersId.filter(p => !IsNullOrUndefined(p.faxNumberId) && !IsNullOrUndefined(p.establishmentId));

        return {
            ...healthCareProvider,
            licenseNumber: IsNullOrWhiteSpace(healthCareProvider.licenseNumber) ? null : healthCareProvider.licenseNumber,
            licenseOrganizationSpecializationId: !IsNullOrWhiteSpace(healthCareProvider.licenseOrganizationSpecializationId) ? healthCareProvider.licenseOrganizationSpecializationId : null,
            faxNumber: !IsNullOrWhiteSpace(healthCareProvider.faxNumber?.number) ? healthCareProvider.faxNumber : null,
            linkedEstablishmentsAndFaxNumbersId: linkedEstablishmentsAndFaxNumbersId
        };
    }

    public static toAddDto(healthCareProvider: DirectoryHealthCareProvider): DirectoryHealthCareProviderAddDto {
        if (!healthCareProvider)
            throw new Error("healthCareProvider cannot be null");

        let linkedEstablishmentsAndFaxNumbersId: DirectoryLinkedEstablishmentAndFaxNumber[] = [];
        for (let i = 0; i < healthCareProvider.linkedEstablishments.length; i++) {
            linkedEstablishmentsAndFaxNumbersId.push({
                establishmentId: healthCareProvider.linkedEstablishments?.[i]?.id,
                faxNumberId: healthCareProvider.linkedFaxNumbers?.[i]?.id
            });
        }

        linkedEstablishmentsAndFaxNumbersId = linkedEstablishmentsAndFaxNumbersId.filter(p => !IsNullOrUndefined(p.faxNumberId) && !IsNullOrUndefined(p.establishmentId));

        return {
            ...healthCareProvider,
            licenseNumber: IsNullOrWhiteSpace(healthCareProvider.licenseNumber) ? null : healthCareProvider.licenseNumber,
            licenseOrganizationSpecializationId: !IsNullOrWhiteSpace(healthCareProvider.licenseOrganizationSpecializationId) ? healthCareProvider.licenseOrganizationSpecializationId : null,
            faxNumber: !IsNullOrWhiteSpace(healthCareProvider.faxNumber?.number) ? healthCareProvider.faxNumber : null,
            linkedEstablishmentsAndFaxNumbersId: linkedEstablishmentsAndFaxNumbersId
        };
    }

    public static toDirectorySelectableEntity(healthCareProvider: DirectoryHealthCareProvider): DirectorySelectableEntity<DirectoryHealthCareProvider> {
        if (!healthCareProvider)
            return;

        const faxInfos = [];

        if (healthCareProvider.faxNumber)
            faxInfos.push({ faxNumber: healthCareProvider.faxNumber, address: healthCareProvider.rawAddress, name: "" });

        faxInfos.push(...healthCareProvider.linkedEstablishments?.flatMap(establishment =>
            establishment.faxNumbers.map(faxNumber => ({
                name: establishment.name,
                address: DirectorySearchHelper.formatAddress(establishment.address),
                faxNumber: faxNumber
            }))) ?? []
        );

        return new DirectorySelectableEntity({
            id: healthCareProvider.id,
            type: DirectoryEntityType.HealthcareProvider,
            address: healthCareProvider.rawAddress,
            faxInfos: faxInfos.filter(p => PhoneNumberHelper.validate(p.faxNumber?.number, p.faxNumber?.countryId)),
            model: healthCareProvider,
            name: healthCareProvider.getDisplayName()
        });
    }

    public static cloneSearchDto(healthCareProvider: DirectoryHealthCareProviderSearchDto): DirectoryHealthCareProviderSearchDto {
        return healthCareProvider
            ? {
                ...healthCareProvider,
                faxNumber: healthCareProvider.faxNumber
                    ? { ...healthCareProvider.faxNumber }
                    : null,
                linkedEstablishments: healthCareProvider.linkedEstablishments?.map(p => DirectoryOtherEstablishmentMapper.cloneSearchDto(p))
            }
            : null;
    }
}
